import { Alert, Button, Spin } from "@arco-design/web-react";

import { useFulfillmentOrderListRuntime } from "../runtime";
import { FulfillmentOrderFilterCard } from "./FulfillmentOrderFilterCard";
import { FulfillmentOrderPaginationBar } from "./FulfillmentOrderPaginationBar";
import { FulfillmentOrderResultTable } from "./FulfillmentOrderResultTable";
import "../../../shared/ui/crmListPageLayout.css";
import "./fulfillmentOrder.css";

/** 确认件内部列表页。 */
export function FulfillmentOrderListFeaturePage() {
  const runtime = useFulfillmentOrderListRuntime();
  return (
    <main className="fulfillment-order-list-page crm-list-page" aria-label="确认件列表">
      <FulfillmentOrderFilterCard
        filters={runtime.draftFilters}
        onChange={runtime.setDraftFilters}
        onSearch={runtime.search}
        onReset={runtime.reset}
      />
      <section className="crm-list-panel fulfillment-order-result-card" aria-busy={runtime.isFetching}>
        <div className="crm-list-section-header">
          <div className="crm-list-title-row">
            <h2>确认件列表</h2>
            <div className="crm-list-statline">共 {runtime.data?.total ?? 0} 条</div>
          </div>
          <div className="crm-list-table-actions">
            <Button type="primary" href="/product-lines/course-routes">
              从课程线路进入
            </Button>
          </div>
        </div>
        {runtime.isFetching && !runtime.isLoading ? <div className="fulfillment-order-list-feedback" role="status"><Spin size={16} /> 正在更新确认件列表…</div> : null}
        {runtime.error ? <Alert type="error" title="确认件列表暂时无法加载" content="请重试或调整筛选条件后重新查询。" action={<Button onClick={() => void runtime.refetch()}>重试</Button>} /> : null}
        {runtime.isLoading ? (
          <div className="fulfillment-order-loading">
            <Spin dot />
          </div>
        ) : (
          <FulfillmentOrderResultTable items={runtime.data?.items ?? []} onSort={runtime.setSort} sortField={runtime.sortField} sortDirection={runtime.sortDirection} sortCleared={runtime.sortCleared} loading={runtime.isFetching} />
        )}
        <FulfillmentOrderPaginationBar
          page={runtime.page}
          pageSize={runtime.pageSize}
          total={runtime.data?.total ?? 0}
          onPageChange={runtime.setPage}
          onPageSizeChange={runtime.setPageSize}
        />
      </section>
    </main>
  );
}
